import { render, staticRenderFns } from "./CreateNewsEditor.vue?vue&type=template&id=d4c28a8e&scoped=true&"
import script from "./CreateNewsEditor.vue?vue&type=script&lang=js&"
export * from "./CreateNewsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c28a8e",
  null
  
)

export default component.exports